import React from 'react';

import SimpleHeader from '../../../../../main/headers/simpleHeader';
import { t } from '../../../../../../modules/infra/i18n';

export default () => (
  <div>
    <SimpleHeader heading={t('customers:duplicates.duplicate_records_heading')} />
    <div className="c-wrapper o-page-height">
      <div className="c-heading c-heading--small c-heading--semibold u-mt">
        {t('customers:duplicates.no_duplicates_found')}
      </div>
    </div>
  </div>
);
